/**
 * useUserBookedSessions Hook
 * Fetches paid rituals the user has booked/joined
 */

import { useQuery } from "@tanstack/react-query"
import { getUserBookedSessions } from "../services/user-rituals.service"

interface UseUserBookedSessionsOptions {
  page?: number
  limit?: number
  search?: string
  enabled?: boolean
}

export function useUserBookedSessions(options?: UseUserBookedSessionsOptions) {
  return useQuery({
    queryKey: ["user-booked-sessions", options?.page, options?.limit, options?.search],
    queryFn: () =>
      getUserBookedSessions({
        page: options?.page,
        limit: options?.limit,
        search: options?.search,
      }),
    enabled: options?.enabled ?? true,
    staleTime: 1000 * 60 * 5,
  })
}
